<template>
  <el-popover
    placement="top-start"
    :show-after="300"
    :hide-after="0"
    width="auto"
    style="top: 5px"
    popper-class="sakura-port-popover"
    trigger="hover"
    :popper-options="{
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: getOffsetByPlacement(placement) // dynamic based on 'left' or 'right'
          }
        },
        {
          name: 'preventOverflow',
          options: {
            boundary: 'viewport'
          }
        },
        {
          name: 'flip',
          options: {
            fallbackPlacements: ['top', 'right', 'left']
          }
        }
      ]
    }"
    :disabled="Boolean(!popover || Boolean(isFanout))"
    @after-enter="initInfoHandle"
  >
    <portLanInfo
      :port="port"
      :showProfile="calcShowProfile"
      :received.sync="received"
      :transmitted.sync="transmitted"
      ref="lanInfoRef"
    />

    <template #reference>
    <div class="sakura-port-lan" @click="activeHandler">
      <!-- Right Top -->
      <img
        class="port-status port-selected"
        src="/static/images/port/selected.png"
        v-if="value && !isEnabledTu"
        :style="{top: dynamicTop}"
      />
      <!-- Tu -->
      <div class="port-status port-tu" v-if="tu === 2 && isEnabledTu"
           :style="{top: dynamicTop}"
      >
        <img src="/static/images/port/trunk.png" style="width: 9px; height: 9px;" />
      </div>
      <img
        class="port-status port-tu"
        src="/static/images/port/selected.png"
        v-if="tu === 1 && isEnabledTu"
        :style="{top: dynamicTop}"
      />

      <div
        class="lan-content"
        :class="[statusClass, borderStatusClass, invert ? 'lan-invert' : '', isQ28 ? 'lan-content-long' : '']"
      >
        <template v-if="isLockMbps">
          <div class="lockMbps-view">
            <div class="circle-style"></div>
            <div class="circle-lan-content">
              <div class="lan-one" :style="{ backgroundColor: calcColor }"></div>
              <div class="lan-two" :style="{ backgroundColor: calcColor }"></div>
              <div class="lan-three" :style="{ backgroundColor: calcColor }">
                <div class="lan-font" :class="{ 'special-font': isSpecial }">
                  <slot></slot>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else-if="isLockFiber">
          <div class="lockFiber-view">
            <div class="circle-style"></div>
            <div class="circle-lan-content">
              <div class="fib-view" :style="{ backgroundColor: calcColor }">
                <div class="fib-line fib-one" :style="{ borderColor: calcColor }"></div>
                <div class="fib-line fib-two" :style="{ borderColor: calcColor }"></div>
                <div class="fib-line fib-three" :style="{ borderColor: calcColor }"></div>
                <div class="fib-line fib-four" :style="{ borderColor: calcColor }"></div>
                <div class="fib-line fib-five" :style="{ borderColor: calcColor }"></div>
                <div class="lan-font" :class="{ 'special-font': isSpecial }">
                  <slot></slot>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else-if="isMbps">
          <div class="lan-one" :style="{ backgroundColor: calcColor }"></div>
          <div class="lan-two" :style="{ backgroundColor: calcColor }"></div>
          <div class="lan-three" :style="{ backgroundColor: calcColor }">
            <div class="lan-font" :class="{ 'special-font': isSpecial }">
              <slot></slot>
            </div>
          </div>
        </template>
        <template v-else-if="isFiber">
          <div class="fib-view" :style="{ backgroundColor: calcColor }">
            <div class="fib-line fib-one" :style="{ borderColor: calcColor }"></div>
            <div class="fib-line fib-two" :style="{ borderColor: calcColor }"></div>
            <div class="fib-line fib-three" :style="{ borderColor: calcColor }"></div>
            <div class="fib-line fib-four" :style="{ borderColor: calcColor }"></div>
            <div class="fib-line fib-five" :style="{ borderColor: calcColor }"></div>
            <div class="lan-font" :class="{ 'special-font': isSpecial }">
              <slot></slot>
            </div>
          </div>
        </template>
        <template v-else-if="isQ28">
          <div class="fib-view-long" :style="{ backgroundColor: calcColor }">
            <div class="fib-line fib-one" :style="{ borderColor: calcColor }"></div>
            <div class="fib-line fib-two" :style="{ borderColor: calcColor }"></div>
            <div class="fib-line fib-three" :style="{ borderColor: calcColor }"></div>
            <div class="fib-line fib-four" :style="{ borderColor: calcColor }"></div>
            <div class="fib-line fib-five" :style="{ borderColor: calcColor }"></div>
            <div class="lan-font" :class="{ 'special-font': isSpecial }">
              <slot></slot>
            </div>
          </div>
        </template>
      </div>

      <!-- Right Bottom -->
      <div
        class="port-status port-poe"
        v-if="showMode('poe') && showStatus('poe')"
        :style="{ zIndex: getZIndex('poe'), bottom: dynamicBottom }"
      >
        <img src="/static/images/port/PoE.png" />
      </div>
      <div
        class="port-status port-poe"
        v-if="showMode('poeDisabled') && showStatus('poeDisabled')"
        :style="{ zIndex: getZIndex('poeDisabled'), bottom: dynamicBottom }"
      >
        <img src="/static/images/port/PoE-disabled.png" />
      </div>

      <div
        class="port-status port-S"
        v-if="showMode('S') && showStatus('S')"
        :style="{ zIndex: getZIndex('S'), bottom: dynamicBottom }"
      >
        <img src="/static/images/port/S.png" />
      </div>

      <div
        class="port-status port-Sa"
        v-if="showMode('S+') && showStatus('S+')"
        :style="{ zIndex: getZIndex('S+'), bottom: dynamicBottom }"
      >
        <img src="/static/images/port/S+.png" />
      </div>

      <div
        class="port-status port-S28"
        v-if="showMode('S28') && showStatus('S28')"
        :style="{ zIndex: getZIndex('S28'), bottom: dynamicBottom }"
      >
        <img src="/static/images/port/S28.png" />
      </div>

      <div
        class="port-status port-QSpuls"
        v-if="showMode('QS+') && showStatus('QS+')"
        :style="{ zIndex: getZIndex('QS+'), bottom: dynamicBottom }"
      >
        <img src="/static/images/port/QSplus.png" />
      </div>

      <div
        class="port-status port-Q28"
        v-if="showMode('Q28') && showStatus('Q28')"
        :style="{ zIndex: getZIndex('Q28'), bottom: dynamicBottom }"
      >
        <img src="/static/images/port/Q28.png" />
      </div>

      <div
        class="port-status port-S56"
        v-if="showMode('S56')"
        :style="{ zIndex: getZIndex('S56'), bottom: dynamicBottom }"
      >
        <img src="/static/images/port/S56.png" />
      </div>

      <div
        class="port-status port-block"
        v-if="showMode('block') && showStatus('block')"
        :style="{ zIndex: getZIndex('block'), bottom: dynamicBottom }"
      >
        <img src="/static/images/port/Block.png" />
      </div>

      <div
        class="port-status port-admin-down"
        v-if="showMode('adminDown') && showStatus('adminDown')"
        :style="{ zIndex: getZIndex('adminDown'), bottom: dynamicBottom }"
      >
        <img src="/static/images/port/admin-down.png" style="width: 4px;" />
      </div>

      <div
        class="port-status port-trunk"
        v-if="showMode('trunk') && showStatus('trunk')"
        :style="{ zIndex: getZIndex('trunk'), bottom: dynamicBottom }"
      >
        <img src="/static/images/port/trunk.png" style="width: 9px; height: 9px;" />
      </div>

      <div
        class="port-status port-LAG"
        v-if="showMode('L') && lag && showStatus('L')"
        :style="{ zIndex: getZIndex('L'), bottom: dynamicBottom }"
        style="width: 25px; height: 25px;"
      >
        <span class="f12" style="margin-top: 6px;">L<label>{{ lag }}</label></span>
      </div>

      <div
        class="port-status port-autoTrunk"
        v-if="showMode('autoTrunk') && showStatus('autoTrunk')"
        :style="{ zIndex: getZIndex('autoTrunk'), bottom: dynamicBottom }"
        style="width: 20px; height: 20px;"
      >
        <span class="f14" style="margin-top: 3px;">A</span>
      </div>

      <div
        class="port-status port-manualTrunk"
        v-if="showMode('manualTrunk') && showStatus('manualTrunk')"
        :style="{ zIndex: getZIndex('manualTrunk'), bottom: dynamicBottom }"
        style="width: 20px; height: 20px;"
      >
        <span class="f14" style="margin-top: 3px;">M</span>
      </div>

      <div
        class="port-status port-fanout"
        v-if="showMode('fanout') && showStatus('fanout')"
        :style="{ zIndex: getZIndex('fanout'), bottom: dynamicBottom }"
        style="width: 20px; height: 20px;"
      >
        <span class="f14" style="margin-top: 3px;">F</span>
      </div>

      <div
        class="port-status port-authorized"
        v-if="showMode('Authorized') && showStatus('Authorized') && !(showModeSpecial('Authorized') || showModeSpecial('Unauthorized'))"
        :style="{ zIndex: getZIndex('Authorized'), bottom: dynamicBottom }"
      >
        <img src="/static/images/port/authorized.png" />
      </div>

      <div
        class="port-status port-unauthorized"
        v-if="showMode('Unauthorized') && showStatus('Unauthorized') && !(showModeSpecial('Authorized') || showModeSpecial('Unauthorized'))"
        :style="{ zIndex: getZIndex('Unauthorized'), bottom: dynamicBottom }"
      >
        <img src="/static/images/port/unauthorized.png" />
      </div>

      <div
        class="port-status port-block-multicast"
        v-if="showMode('blockMulticast') && showStatus('blockMulticast')"
        :style="{ zIndex: getZIndex('blockMulticast'), bottom: dynamicBottom }"
      >
        <img src="/static/images/port/Block.png" />
      </div>

      <div
        class="port-status port-force-multicast"
        v-if="showMode('forceMulticast') && showStatus('forceMulticast')"
        :style="{ zIndex: getZIndex('forceMulticast'), bottom: dynamicBottom }"
      >
        <i class="el-icon-rank"></i>
      </div>

      <div
        class="port-status port-dynamic"
        v-if="showMode('dynamic') && showStatus('dynamic')"
        :style="{ zIndex: getZIndex('dynamic'), bottom: dynamicBottom }"
      >
        <img src="/static/images/port/dynamic.png" style="width: 20px; height: 20px;" />
      </div>

      <div
        class="port-status port-warning"
        v-if="showMode('warning') && showStatus('warning')"
        :style="{ zIndex: getZIndex('warning'), bottom: dynamicBottom }"
      >
        <!-- <img src="/static/images/port/warning.png" /> -->
      </div>
      <div class="port-status port-lock" v-if="showMode('lock') && showStatus('lock')"
        :style="{ zIndex: getZIndex('lock'), bottom: dynamicBottom }">
        <img src="/static/images/port/unlock-full.png" />
      </div>
      <div class="port-status port-unlock" v-if="showMode('unlock') && showStatus('unlock')"
        :style="{ zIndex: getZIndex('unlock'), bottom: dynamicBottom }">
        <img src="/static/images/port/lock-full.png" />
      </div>

      <div class="port-status port-lock" v-if="showModeSpecial('Authorized')"
           :style="{ zIndex: 30, bottom: dynamicBottom }"
      >
        <img src="/static/images/port/unlock-full.png" />
      </div>

      <div class="port-status port-unlock" v-if="showModeSpecial('Unauthorized')"
           :style="{ zIndex: 30, bottom: dynamicBottom }"
      >
        <img src="/static/images/port/lock-full.png" />
      </div>

      <!--bottom left-->

      <div class="port-status port-dynamic-special"
        v-if="showModeSpecial('Authorized') || showModeSpecial('Unauthorized')"
        :style="{ zIndex: 30, bottom: dynamicBottom }"
      >
        <img src="/static/images/port/dynamic.png" style="width: 20px;height: 20px;" />
      </div>
      <div class="port-status port-more-type" v-if="showMoreMode('control')"
           :style="{ bottom: dynamicBottom }"
      >
        <img src="/static/images/port/more-control.png" style="width: 16px;height: 16px;" />
      </div>
      <div class="port-status port-more-type" v-if="showMoreMode('audio')"
           :style="{ bottom: dynamicBottom }"
      >
        <img src="/static/images/port/more-audio.png" style="width: 16px;height: 16px;" />
      </div>
      <div class="port-status port-more-type" v-if="showMoreMode('video')"
           :style="{ bottom: dynamicBottom }"
      >
        <img src="/static/images/port/more-video.png" style="width: 16px;height: 16px;" />
      </div>

      <!--  top left    -->
      <div class="port-status port-vendor" v-if="!!calcVendor.vendor" :class="{
        'port-vendor-visionary': ['visionary', 'NUCLEUS', 'lightware'].includes(calcVendor.vendor),
        'port-vendor-kramer': ['kramer'].includes(calcVendor.vendor),
        'port-vendor-full': ['genelec', 'nice', 'etc'].includes(calcVendor.vendor),
        'port-vendor-round': ['GandD'].includes(calcVendor.vendor),
      }" :style="{ zIndex: 30, top: dynamicTop }">
        <img :src="`/static/images/port/${calcVendor.vendor}.png`" />
      </div>
    </div>
    </template>
  </el-popover>
</template>

<script setup>
import {
  ref,
  computed,
  defineProps,
  defineEmits,
  inject,
  onMounted,
  watch,
  getCurrentInstance
} from 'vue'
import { ColorUtil } from '../../js/util'
import portLanInfo from './sakura-port-lan-info'
import { useRoute } from 'vue-router';
import { useMainStore } from '@/stores'

const props = defineProps({
  popover: {
    type: Boolean,
    default: false
  },
  invert: {
    type: Boolean,
    default: false
  },
  port: {
    type: Number,
    default: 0
  },
  value: {
    type: Boolean,
    default: false
  },
  isEnabled: {
    type: Boolean,
    default: true
  },
  hex: {
    type: String,
    default: '#409EFF'
  },
  lag: {
    type: [String, Number],
    default: ''
  },
  type: {
    type: String,
    default: 'mbps',
    validator: value => ['mbps', 'fiber', 'q28'].includes(value)
  },
  mode: {
    type: Array,
    default: () => []
  },
  status: {
    type: String,
    default: '',
    validator: value => ['', 'disabled', 'available'].includes(value)
  },
  borderStatus: {
    type: String,
    default: '',
    validator: value => ['', 'connected', 'connected-powered', 'error'].includes(value)
  },
  priority: {
    type: Array,
    default: () => []
  },
  isEnabledTu: {
    type: Boolean,
    default: false
  },
  tu: {
    type: Number,
    default: 0,
    validator: value => [0, 1, 2].includes(value)
  },
  vendor: {
    type: String,
    default: ''
  },
  config: {
    type: Object,
    default: () => ({})
  },
  detach: {
    type: Boolean,
    default: false
  },
  isFanout: {
    type: [Boolean, Number],
    default: false
  },
  slotShowLock: {
    type: Boolean,
    default: false
  },
  portShowLock: {
    type: Boolean,
    default: false
  }
})
const { proxy } = getCurrentInstance();
const mainStore = useMainStore();
const model = computed(() => mainStore.unitModel)

const route = useRoute();
const lanInfoRef = ref(null)

const emit = defineEmits(['port-click', 'port-click-fanout', 'update:tu', 'input', 'change'])

const network = inject('network', null)

const received = ref(false)
const transmitted = ref(false)
const visible = ref(true)
const placement = 'top-start';

const isLockMbps = computed(() =>
  props.type === 'mbps' && model.value === 'M4350-16M4V' && (props.portShowLock || props.slotShowLock)
)
const isLockFiber = computed(() => {
  return props.type === 'fiber' && model.value === 'M4350-16M4V' && props.slotShowLock
  }
)
const isMbps = computed(() => props.type === 'mbps')
const isFiber = computed(() => props.type === 'fiber')
const isQ28 = computed(() => props.type === 'q28')

const statusClass = computed(() => props.status ? `lan-${props.status}` : '')
const borderStatusClass = computed(() => props.borderStatus ? `lan-${props.borderStatus}` : '')

const isSpecial = computed(() => {
  return props.hex !== '#000000' && proxy.$sakura.contrastColor(props.hex) === '#000000'
})

const calcColor = computed(() => props.detach ? '#6E6E6E' : props.hex)

const calcVendor = computed(() => {
  const [vendor, type] = props.vendor.split(' ')
  return { vendor, type }
})

const calcMode = computed(() => (props.isFanout ? ['fanout', ...props.mode] : props.mode))
const calcPriority = computed(() => {

  const isMulticastRoute = route.path === '/configure/multicast';
  let _arr = props.priority
  if (!isMulticastRoute) {
    _arr = props.priority.filter(key=> key !== 'blockMulticast' && key !== 'forceMulticast')
  }

  return ['fanout', ..._arr]
})

const calcShowProfile = computed(() => {
  const { lag, priority, calcMode } = props
  const arr = [
    showMode('autoTrunk') && showStatus('autoTrunk'),
    showMode('L') && lag && showStatus('L'),
    showMode('manualTrunk') && showStatus('manualTrunk')
  ]
  return arr.filter(item => !!item).length === 0
})

const dynamicBottom = computed(() => (props.port !== 0 && model.value === 'M4350-16M4V' ? '18px' : '3px'));
const dynamicTop = computed(() => (props.port !== 0 && model.value === 'M4350-16M4V' ? '18px' : '3px'));

const initInfoHandle = () => {
  lanInfoRef.value?.open?.()
}

const leaveHandle = () => {
  lanInfoRef.value?.close?.()
}

const showMoreMode = type => type === calcVendor.value.type

const getZIndex = mode => {
  let zIndex = 10
  const arr = [...calcPriority.value].reverse()
  arr.some((item, index) => {
    if (item === mode) {
      zIndex = zIndex + index
      return true
    }
  })
  return zIndex
}

const showStatus = name => {
  const cur = getZIndex(name)
  const maxNumber = (array, number = 1) => [...array].sort((a, b) => b - a).slice(0, number)
  const arr = calcMode.value.map(key => getZIndex(key))
  const [max] = maxNumber(arr, 1)
  return max === cur
}

const showMode = name => {
  const arr = ['autoTrunk', 'L', 'autoTrunk', 'manualTrunk', 'fanout'];
  const priority = [...calcPriority.value];

  if (props.isEnabledTu) {
    if (priority.length > 0) {
      return arr.includes(name) && priority.filter(item => calcMode.value.includes(item) && item === name).length
    } else return false
  } else {
    if (priority.length) {
      return priority.filter(item => calcMode.value.includes(item) && item === name).length
    } else return false
  }
}

const showModeSpecial = name => {
  const priority = [...calcPriority.value]
  const arr = ['Authorized', 'Unauthorized']
  if (props.isEnabledTu) {
    return false
  } else {
    if (priority && (priority.length > 0)) {
      const isPriority = priority.some(item => arr.includes(item))
      const isMode = calcMode.value.some(item => arr.includes(item))
      return isPriority && isMode && calcMode.value.includes('dynamic') && calcMode.value.includes(name)
    } else return false
  }
}

function getOffsetByPlacement(placement) {
  switch (placement) {
    case 'left':
      return [-10, 0]; // x: -10px shift to left
    case 'right':
      return [10, 0];  // x: +10px shift to right
    default:
      return [0, 0];   // default, no offset
  }
}

const activeHandler = () => {
  if (props.isFanout) {
    emit('port-click-fanout');
  } else {
    emit('port-click')
    if (props.isEnabledTu) {
      let num = props.tu + 1
      if (num > 2) num = 0
      emit('update:tu', num)
    } else {
      if (props.isEnabled) {
        emit('input', !props.value)
        emit('change', !props.value)
      }
    }
    if (network) {
      network.updateUnitSelect()
    }
  }
}
</script>



<style lang="scss" scoped>
@use "@/css/base.scss" as *;
@use "@/css/mixin.scss" as *;

.sakura-port-lan {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  cursor: pointer;
  user-select: none;
  position: relative;
  outline: none;

  .lan-content {
    width: 35px;
    height: 30px;
    position: relative;

    .lan-one,
    .lan-two,
    .lan-three {
      background-color: #2c262d;
      border: 2px solid #504b51;
      position: absolute;
    }

    .lan-one {
      height: 4px;
      width: 8px;
      top: 1px;
      z-index: 3;
      border-bottom: none;
      left: calc(35px / 2 - 8px / 2);
    }

    .lan-two {
      height: 5px;
      width: 28px;
      top: 3px;
      z-index: 2;
      border-bottom: none;
      left: calc(35px / 2 - 28px / 2);
    }

    .lan-three {
      height: 24px;
      width: 100%;
      line-height: 23px;
      bottom: 0;
      z-index: 1;
    }

    .lan-font {
      height: 100%;
      line-height: 16px;
    }


    .fib-view {
      width: 36px;
      height: 30px;
      line-height: 25px;
      border: 2px solid #504b51;
      background: #2c262d;
      color: #656565;
      position: relative;

      .fib-line {
        width: 1px;
        height: 5px;
        border: none;
        @include inlineBlock();
        position: absolute;
        background-color: #504b51;
      }

      .fib-one {
        left: calc(50% - 1px);
      }

      .fib-two {
        bottom: 3px;
        left: 2px;
        height: 6px;
        transform: rotate(90deg);
      }

      .fib-three {
        bottom: 1px;
        left: calc(50% - 1px);
        height: 10px;
        transform: rotate(90deg);
      }

      .fib-four {
        bottom: 3px;
        right: 2px;
        height: 6px;
        transform: rotate(90deg);
      }

      .fib-five {
        left: calc(50% - 1px);
        bottom: 0;
      }

      .lan-font {
        height: 100%;
        line-height: 25px;
      }
    }

    .lockMbps-view {

      display: flex;
      align-items: center;
      justify-content: center;

      .lan-one,
      .lan-two,
      .lan-three {
        background-color: #2c262d;
        border: 2px solid #504b51;
        position: absolute;
      }

      .lan-one {
        height: 4px;
        width: 8px;
        top: 1px;
        z-index: 3;
        border-bottom: none;
        left: calc(35px / 2 - 8px / 2);
      }

      .lan-two {
        height: 5px;
        width: 28px;
        top: 3px;
        z-index: 2;
        border-bottom: none;
        left: calc(35px / 2 - 28px / 2);
      }

      .lan-three {
        height: 24px;
        width: 100%;
        line-height: 23px;
        bottom: 0;
        z-index: 1;
      }

      .circle-style {
        border: 3px solid #2C262D;
        width: 60px;
        height: 60px;
        border-radius: 50%;
        position: absolute;
      }

      .circle-lan-content {
        width: 36px;
        height: 30px;
        position: relative;
      }
    }

    .lockFiber-view {
      display: flex;
      align-items: center;
      justify-content: center;

      .circle-style {
        border: 3px solid #2C262D;
        width: 60px;
        height: 60px;
        border-radius: 50%;
        position: absolute;
      }

      .circle-fib-content {
        width: 36px;
        height: 30px;
        position: relative;

        .fib-view {
          width: 36px;
          height: 30px;
          line-height: 25px;
          border: 2px solid #504b51;
          background: #2c262d;
          color: #656565;
          position: relative;

          .fib-line {
            width: 1px;
            height: 5px;
            border: none;
            position: absolute;
            background-color: #504b51;
          }

          .fib-one {
            left: calc(50% - 1px);
          }

          .fib-two {
            bottom: 3px;
            left: 2px;
            height: 6px;
            transform: rotate(90deg);
          }

          .fib-three {
            bottom: 1px;
            left: calc(50% - 1px);
            height: 10px;
            transform: rotate(90deg);
          }

          .fib-four {
            bottom: 3px;
            right: 2px;
            height: 6px;
            transform: rotate(90deg);
          }

          .fib-five {
            left: calc(50% - 1px);
            bottom: 0;
          }

          .lan-font {
            height: 100%;
            line-height: 25px;
          }
        }
      }
    }

  }

  .lan-content-long {
    width: 45px;

    .fib-view-long {
      width: 46px;
      height: 30px;
      line-height: 25px;
      border: 2px solid #504b51;
      background: #2c262d;
      color: #656565;
      position: relative;

      .fib-line {
        width: 1px;
        height: 5px;
        border: none;
        @include inlineBlock();
        position: absolute;
        background-color: #504b51;
      }

      .fib-one {
        left: calc(50% - 1px);
      }

      .fib-two {
        bottom: 3px;
        left: 2px;
        height: 6px;
        transform: rotate(90deg);
      }

      .fib-three {
        bottom: 1px;
        left: calc(50% - 1px);
        height: 10px;
        transform: rotate(90deg);
      }

      .fib-four {
        bottom: 3px;
        right: 2px;
        height: 6px;
        transform: rotate(90deg);
      }

      .fib-five {
        left: calc(50% - 1px);
        bottom: 0;
      }

      .lan-font {
        height: 100%;
        line-height: 25px;
      }
    }
  }

  .lan-invert {
    .lan-font {
      height: 100%;
      line-height: 25px;
    }
  }

  .lan-connected {

    .lan-one,
    .lan-two,
    .lan-three,
    .fib-view,
    .fib-view-long {
      border-color: #00D76F;
      color: #fff;
    }

    .lockMbps-view {
      .lan-one,
      .lan-two,
      .lan-three {
        border-color: #00D76F;
      }
    }

    .fib-view,
    .fib-view-long {
      border-color: #00D76F;

      .fib-one,
      .fib-two,
      .fib-three,
      .fib-four,
      .fib-five {
        background-color: #00D76F;
      }
    }
  }

  .lan-connected-powered {

    .lan-one,
    .lan-two,
    .lan-three,
    .fib-view,
    .fib-view-long {
      border-color: #409EFF;
      color: #fff;
    }

    .lockMbps-view {
      .lan-one,
      .lan-two,
      .lan-three {
        border-color: #409EFF;
      }
    }

    .fib-view,
    .fib-view-long {

      .fib-one,
      .fib-two,
      .fib-three,
      .fib-four,
      .fib-five {
        background-color: #409EFF;
      }
    }
  }

  .lan-error {

    .lan-one,
    .lan-two,
    .lan-three {
      border-color: #fc3858;
      color: #fff;
    }

    .lockMbps-view {
      .lan-one,
      .lan-two,
      .lan-three {
        border-color: #fc3858;
        color: #fff;
      }
    }

    .fib-view,
    .fib-view-long {
      border-color: #fc3858;

      .fib-one,
      .fib-two,
      .fib-three,
      .fib-four,
      .fib-five {
        background-color: #fc3858;
      }
    }
  }

  .lan-disabled {

    .lan-one,
    .lan-two,
    .lan-three,
    .fib-view,
    .fib-view-long {
      background: #707070 !important;
    }

    .lockMbps-view {
      .lan-one,
      .lan-two,
      .lan-three {
        background: #707070 !important;
      }
    }

    .fib-view,
    .fib-view-long {

      .fib-one,
      .fib-two,
      .fib-three,
      .fib-four,
      .fib-five {
        background-color: #707070 !important;
      }
    }

    .lan-font {
      color: #999 !important;
    }
  }

  .lan-available {

    .lan-one,
    .lan-two,
    .lan-three,
    .fib-view,
    .fib-view-long {
      background: #0B0B0B;
      color: #fff;
    }

    .lockMbps-view {
      .lan-one,
      .lan-two,
      .lan-three {
        background: #0B0B0B;
        color: #fff;
      }
    }
  }

  .lan-invert {
    transform: rotate(-180deg);

    .lan-font {
      transform: rotate(180deg);
    }
  }

  .port-status {
    @include wh(20px, 20px);
    @include inlineBlock();
    background-color: #fff;
    border-radius: 100%;
    text-align: center;
    position: relative;

    img,
    i {
      position: absolute;
      top: 50%;
      left: 50%;
      font-size: 12px;
      @include wh(12px, 12px);
      transform: translate(-50%, -50%);
    }
  }

  .port-selected,
  .port-tu {
    position: absolute;
    top: 3px;
    left: calc(100% / 2 + 20px / 4);
    z-index: 10;
  }

  .port-poe,
  .port-S,
  .port-Sa,
  .port-S28,
  .port-QSpuls,
  .port-Q28,
  .port-S56,
  .port-block,
  .port-admin-down,
  .port-L,
  .port-LAG,
  .port-trunk,
  .port-authorized,
  .port-unauthorized,
  .port-autoTrunk,
  .port-manualTrunk,
  .port-fanout,
  .port-block-multicast,
  .port-force-multicast,
  .port-dynamic,
  .port-warning,
  .port-lock,
  .port-unlock {
    position: absolute;
    bottom: 3px; //-3px
    left: calc(100% / 2 + 20px / 4);
    z-index: 10;
  }

  .port-LAG,
  .port-autoTrunk,
  .port-manualTrunk,
  .port-fanout,
  .port-warning {
    line-height: 1;

    span {
      transform: scale(0.8);
      display: inline-block;
      font-weight: bold;
      color: #303639;
      white-space: nowrap;
    }
  }

  .port-S,
  .port-Sa {
    img {
      width: 10px;
      height: 10px;
    }
  }

  .port-S28,
  .port-QSpuls,
  .port-Q28 {
    img {
      width: 80%;
      height: 80%;
    }
  }

  .port-S56 {
    img {
      width: 90%;
      height: 90%;
    }
  }

  .port-dynamic-special,
  .port-more-type {
    position: absolute;
    bottom: 3px;
    left: calc(100% / 2 - 27px);
    z-index: 10;
  }

  .port-vendor {
    position: absolute;
    top: 3px;
    left: calc(100% / 2 - 27px);
    z-index: 10;

    img {
      width: 18px;
      height: 14px;
    }
  }

  .port-no-vendor {
    background-color: #4E81C2;
  }

  .lan-font {
    color: #fff;
    text-align: center;
    white-space: nowrap;
  }

  .special-font {
    color: #000000;
  }

  .port-vendor-visionary {
    img {
      width: 15px;
      height: 15px;
    }
  }

  .port-vendor-kramer {
    img {
      width: 22px;
      height: 22px;
    }
  }

  .port-vendor-full {
    img {
      width: 22px;
      height: 22px;
    }
  }

  .port-vendor-round {
    img {
      width: 21px;
      height: 21px;
      border-radius: 50%;
    }
  }
}
</style>
